import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Upload from "@/pages/Upload";
import Profile from "@/pages/Profile";
import PostDetail from "@/pages/PostDetail";
import Leaderboard from "@/pages/Leaderboard";
import Pricing from "@/pages/Pricing";
import Payouts from "@/pages/Payouts";
import Discover from "@/pages/Discover";
import Admin from "@/pages/Admin";
import Appeal from "@/pages/Appeal";
import Changelog from "@/pages/legal/Changelog";
import ConsentGate from "@/components/ConsentGate";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Guidelines from "@/pages/legal/Guidelines";
import Dmca from "@/pages/legal/Dmca";
import Disclaimer from "@/pages/legal/Disclaimer";
import Cookies from "@/pages/legal/Cookies";
import ReferralRedirect from "@/pages/ReferralRedirect";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentReturn";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/upload" element={<Upload />} />
                        <Route path="/u/:username" element={<Profile />} />
                        <Route path="/p/:id" element={<PostDetail />} />
                        <Route path="/leaderboard" element={<Leaderboard />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/payouts" element={<Payouts />} />
                        <Route path="/discover" element={<Discover />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/appeal" element={<Appeal />} />
                        <Route path="/legal/changelog" element={<Changelog />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/guidelines" element={<Guidelines />} />
                        <Route path="/dmca" element={<Dmca />} />
                        <Route path="/disclaimer" element={<Disclaimer />} />
                        <Route path="/cookies" element={<Cookies />} />
                        <Route path="/r/:code" element={<ReferralRedirect />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                    </Routes>
                    <Footer />
                    <CookieBanner />
                    <ConsentGate />
                    <Toaster position="top-center" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
